import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";



// this code is created an instance with base url for admin
export const cmsInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL_CMS}`,
});
// this code is created an instance with base url for admin
export const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/admin`,
});

export const setJwtToken = () => {
  const token = localStorage.getItem("community_token")
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
};


export const setMultiPartHeader = () => {
  const token = localStorage.getItem("community_token")
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };
};

// this interceptors checks user's token is valid or not
export const AxiosInterceptor = ({ children }) => {
  const [isSet, setIsSet] = useState(false);
  const navigate = useNavigate();

  const removeToken = () => {
    localStorage.removeItem("community_token")
  }

  useEffect(() => {
    const resInterceptor = (response) => {
      if (response?.data?.status === 401) {
        removeToken();
        navigate("/");
      }
      return response;
    };

    const errInterceptor = (error) => {
      if (error?.code === "ERR_NETWORK") {
        return toast.error(error?.message,{id:"1"})
      }
      if (error?.response?.data?.status === 401) {
        removeToken();
        navigate("/");
      }
      return error;
    };

    const interceptor = instance.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );
    setIsSet(true);

    return () => instance.interceptors.response.eject(interceptor);
    // eslint-disable-next-line
  }, []);

  return isSet && children;
};
